import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  cover_image: string;
  read_time: number;
  published_at: string;
  category: string;
}

export function useBlogPosts(category?: string, search?: string) {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPosts() {
      try {
        let query = supabase
          .from('blog_posts')
          .select('*')
          .eq('status', 'published')
          .order('published_at', { ascending: false });

        if (category && category !== 'All') {
          query = query.eq('category', category);
        }

        if (search) {
          query = query.or(`title.ilike.%${search}%,excerpt.ilike.%${search}%`);
        }

        const { data, error: fetchError } = await query;

        if (fetchError) {
          console.error('Database query error:', fetchError);
          throw new Error('Failed to fetch blog posts');
        }

        setPosts(data || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching blog posts:', err);
        setError('Failed to load blog posts. Please try again later.');
        setPosts([]);
      } finally {
        setLoading(false);
      }
    }

    setLoading(true);
    fetchPosts();
  }, [category, search]);

  return { posts, loading, error };
}